import PageHeader from "@/components/site/PageHeader";
import ContactForm from "@/components/forms/ContactForm";

export default function ContactPage() {
    return (
        <div data-testid="contact-page">
            <PageHeader
                eyebrow="Contact"
                title="Get in touch."
                description="Questions, feedback, or anything else — send us a note and we'll get back to you."
                testId="contact-header"
            />
            <section className="bg-[#FAFAFA] border-b border-slate-200">
                <div className="max-w-3xl mx-auto px-6 md:px-12 py-12 md:py-20">
                    <ContactForm />
                </div>
            </section>
        </div>
    );
}
